import {SystemUser} from './system-user.model';
import {DictionaryItem} from './dictionary.model';
import {Party} from './party.model';
import {BeneficiaryInformation, Clause} from './product.model';
import {GenericEntity} from './generic-entity.model';
import {Attachment} from './attachment.model';

export enum AmendmentConfigurationType {
    CPI_TERMINATION = 'CPI_TERMINATION',
    CPI_CANCELLATION = 'CPI_CANCELLATION',
    CPI_PERSONAL_DATA = 'CPI_PERSONAL_DATA',
    CPI_BENEFICIARY_CHANGE = 'CPI_BENEFICIARY_CHANGE',
}

export abstract class AmendmentGenericConfiguration {
    configurationType: AmendmentConfigurationType;
    amendmentDate?: string;
    employee?: SystemUser;
}

export class AmendmentCpiCancellation extends AmendmentGenericConfiguration {
    configurationType: AmendmentConfigurationType = AmendmentConfigurationType.CPI_CANCELLATION;
}

export class AmendmentCpiTermination extends AmendmentGenericConfiguration {
    configurationType = AmendmentConfigurationType.CPI_TERMINATION;
    effectiveDate: string;
    reason: DictionaryItem;
    bankAccountNumber: string;
    returnAmount: number;
}

export class AmendmentCpiPersonalData extends AmendmentGenericConfiguration {
    configurationType = AmendmentConfigurationType.CPI_PERSONAL_DATA;
    party: Party;
    cluaseList: Clause[];
}

export class AmendmentCpiBeneficiaryChange extends AmendmentGenericConfiguration {
    configurationType = AmendmentConfigurationType.CPI_BENEFICIARY_CHANGE;
    beneficiaryInformation: BeneficiaryInformation;
}

export class Amendment extends GenericEntity {
    policyId: number;
    sourcePolicyVersionId: number;
    targetPolicyVersionId: number;
    data: AmendmentGenericConfiguration;
    status: DictionaryItem;
    statusDate: string;
    attachmentList: Attachment[];
}
